import {
	ChangeDetectionStrategy,
	Component,
	Input,
	Output,
	EventEmitter,
	inject,
} from '@angular/core';
import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import { CmmsTableService } from '@app/pages/cmms/services/cmms-table.service';
import { NgClass, DatePipe } from '@angular/common';
import { AuBodyTextGreyComponent } from '../../au-body-text-grey/au-body-text-grey-component';
import { AuBodyHeadingComponent } from '../../au-body-heading-component/au-body-heading.component';
import { AuBodyTextComponent } from '../../au-body-text/au-body-text.component';
import { AuPriorityLevelComponent } from '../../au-priority-level/au-priority-level.component';
import { AuLinkedObjectListComponent } from '../../au-linked-object-list/au-linked-object-list.component';
import { AvatarWithNameComponent } from '../../au-avatar-with-name/avatar-with-name.component';
import { AuCmmsStatusLabelComponent } from '../../au-cmms-status-label/au-cmms-status-label.component';
import { AuLinkedObjectBtnComponent } from '../../au-linked-object-btn/au-linked-object-btn.component';
import { AuFileNameComponent } from '../../au-file-name/au-file-name.component';
import { AuKeyValueComponent } from '../../au-key-value-text/au-key-value.component';
import { AuClassificationBadgeComponent } from '../../au-classification-badge/au-classification-badge.component';
import { AuClassificationSuggestionBadgeComponent } from '../../au-classification-suggestion-badge/au-classification-suggestion-badge.component';
import { AuExpandableTagsComponent } from '../../au-expandable-tags/au-expandable-tags.component';
import { AuDocumentTypeComponent } from '../../au-document-type/au-document-type.component';
import { AuNsColumnComponent } from '../../au-ns-column/au-ns-column.component';
import { AuCmmsLabelColumnComponent } from '../../au-cmms-label-column/au-cmms-label-column.component';
import { AssetConditionGradeComponent } from '../../../../pages/cmms/components/assets/asset-condition-grade/asset-condition-grade.component';
import { CmmsAutocompleteContactComponent } from '../../../../pages/cmms/components/shared-form-group-controls/cmms-autocomplete-contact/cmms-autocomplete-contact.component';
import { DateAgoPipe } from '@shared/pipes/date-ago.pipe';
import { NgxMaskPipe } from 'ngx-mask';
import { CmmsEntities } from '@app/domain/types';
import { COLUMN_TYPES } from '../utils/enums';
import { ICMMSLocation } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { ILocationAssetInput } from '@app/pages/cmms/interfaces/assets.interfaces';
@Component({
	selector: 'au-table-cmms-column',
	templateUrl: 'au-table-cmms-column.component.html',
	styleUrls: ['au-table-cmms-column.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		AuBodyTextGreyComponent,
		AuBodyHeadingComponent,
		AuBodyTextComponent,
		AuPriorityLevelComponent,
		AuLinkedObjectListComponent,
		AvatarWithNameComponent,
		AuCmmsStatusLabelComponent,
		NgClass,
		AuLinkedObjectBtnComponent,
		AuFileNameComponent,
		AuKeyValueComponent,
		AuClassificationBadgeComponent,
		AuClassificationSuggestionBadgeComponent,
		AuExpandableTagsComponent,
		AuDocumentTypeComponent,
		AuNsColumnComponent,
		AuCmmsLabelColumnComponent,
		AssetConditionGradeComponent,
		CmmsAutocompleteContactComponent,
		DatePipe,
		DateAgoPipe,
		NgxMaskPipe,
	],
})
export class AuTableCmmsColumnComponent {
	private readonly cmmsTableService = inject(CmmsTableService);
	@Input() usePlaceholderForAvatar = false;
	@Input() column: ICMMSColumn;

	@Input() item: CmmsEntities;
	@Input() mobile = false;

	@Output() selectElement = new EventEmitter<CmmsEntities>();

	COLUMN_TYPES = COLUMN_TYPES;

	/** Regardless this logic we can take nested keys from entities
	 *  as well as non nested. F.E. you can take property 'name'
	 *  or ['location', 'name']
	 * */
	getData(item: CmmsEntities, key: string) {
		return item[key];
	}

	getClassificationSuggestionsData(item: CmmsEntities) {
		if ('classificationSuggestions' in item && item.classificationSuggestions) {
			return item.classificationSuggestions;
		}
		return;
	}

	getDataForLocations(locations: ICMMSLocation[] | ILocationAssetInput) {
		if (!Array.isArray(locations)) {
			return [locations];
		}
		return locations;
	}

	openLinkPressed(event): void {
		this.cmmsTableService.navigateToEntityFromLinkedList(event);
	}

	IsOutdated(item: CmmsEntities): boolean {
		if ('deadline' in item === false || !item.deadline) {
			return false;
		}
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const dueDate = new Date(item.deadline);
		dueDate.setHours(0, 0, 0, 0);
		return dueDate < today;
	}
}
